import React from "react";
import t from "../../i18n";
import { color } from "@ui";
import { Text } from "@ui/Text";
import { FlagFill } from "@ui/IconV2/react";
import type { Analysis } from "../../api/Analysis";
import { analysisTitleLong } from "./Analysis/analysisTitle";
import { spacings } from "@ui/Theme";
import { css } from "@linaria/core";
import cx from "classnames";
import type { Event } from "../../api/useEvents";
import { getEventEndsAt } from "../../domain/event";

interface PropsTitle {
  event: Event | null;
  analysis: Analysis;
  timeZone: string;
  className?: string;
}

export const AnalysisDateTitle = ({ event, analysis, timeZone, className }: PropsTitle) => {
  const analysis_tl = analysisTitleLong(analysis, timeZone);
  const analysis_label = analysis_tl.split(" - ").slice(0, -1).join(" - ");
  const analysis_date = analysis_tl.split(" - ").at(-1);

  const isAnalysisOutsideEventPeriod = React.useMemo(() => {
    if (event === null) return false;
    const endsAt = getEventEndsAt(event);

    return analysis.date < event.startsAt.getTime() || analysis.date > endsAt.getTime();
  }, [analysis, event]);

  return (
    <div className={cx(analysisDateTitle, date, className)}>
      <FlagFill size="m" color={color.darkNitrogen600} />
      <Text type="body1SemiBold">{t("commons.analysis_title")}</Text>
      <Text>
        <Text type="h4" className={date}>
          {analysis_label && (
            <Text type="body1SemiBold" as="span" style={{ color: color.carbon800 }}>
              {analysis_label}
            </Text>
          )}
          <Text as="span" style={{ color: color.carbon800 }}>
            {analysis_date}
          </Text>
        </Text>
        {isAnalysisOutsideEventPeriod && (
          <Text as="span" style={{ color: color.carbon700 }}>
            {t("project.chart.analysis.outside_event_period")}
          </Text>
        )}
      </Text>
    </div>
  );
};

//#region Css
const analysisDateTitle = css`
  flex-wrap: wrap;
`;
const date = css`
  display: flex;
  align-items: center;
  gap: ${spacings.xs};
`;

//#endregion Css
